define('areas/tools/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var FavouriteMobileApps = (function () {
        function FavouriteMobileApps() {
        }
        return FavouriteMobileApps;
    }());
    exports.FavouriteMobileApps = FavouriteMobileApps;
    var MobileAppReview = (function () {
        function MobileAppReview() {
        }
        return MobileAppReview;
    }());
    exports.MobileAppReview = MobileAppReview;
});

